import React from 'react';
import { AgentScalingWorkshop } from './pages/AgentScalingWorkshop';
export function App() {
  return <AgentScalingWorkshop data-id="element-0" data-mp="35ctutf7sahha" />;
}